import {createAsyncThunk} from '@reduxjs/toolkit';
import {AxiosInstance, AxiosResponse} from 'axios';
//enum
import {ACTION_TYPE} from '../actions-types';
import {
	IMakeDonationRequest,
	IMakeDonationResponse,
	IOrganizationMakeDonationRequest,
	IUserDonationResponse,
} from '@/utils/types';
import {UserDonationService} from '@/utils/services/user-donation.service';
//helpers
import {getErrorResponse} from '@/utils/helpers';

export const userMakeDonation = createAsyncThunk(
	ACTION_TYPE.TABLES_AND_TICKETS_DONATIONS,
	async ({reqBody, apiInstance}: {reqBody: IMakeDonationRequest; apiInstance: AxiosInstance}, {rejectWithValue}) => {
		try {
			const userResponse: AxiosResponse<IMakeDonationResponse> = await UserDonationService.makeDonation(
				reqBody,
				apiInstance
			);
			return userResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

export const organizationMakeDonation = createAsyncThunk(
	ACTION_TYPE.ORGANIZATION_FUND_DONATION,
	async (
		{reqBody, apiInstance}: {reqBody: IOrganizationMakeDonationRequest; apiInstance: AxiosInstance},
		{rejectWithValue}
	) => {
		try {
			const organizationResponse: AxiosResponse<void> = await UserDonationService.makeOrganizationDonation(
				reqBody,
				apiInstance
			);
			return organizationResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

export const getDonationListByEvent = createAsyncThunk(
	ACTION_TYPE.TABLES_AND_TICKETS_DONATIONS,
	async ({reqBody, apiInstance}: {reqBody: number; apiInstance: AxiosInstance}, {rejectWithValue}) => {
		try {
			const userResponse: AxiosResponse<IUserDonationResponse> = await UserDonationService.getDonationList(
				reqBody,
				apiInstance
			);
			return userResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);
